<template>
  <mu-card id="top-contributors">
    <mu-card-header
      titleClass="blueTitle largeTitle"
      :title="$t('message.discussionTopContributorsTitle')"
      :subTitle="$t('message.discussionTopContributorsSubTitle')">
    </mu-card-header>
    <mu-card-text>
      <mu-flexbox>
        <mu-flexbox-item v-for="item, index in 5" :key="'contributor-loading-' + index" v-if="isLoading">
          <mu-avatar
            backgroundColor="#E9E9E8"
            :size="40"
          />
        </mu-flexbox-item>
        <mu-flexbox-item v-for="item, index in data" :key="'contributor-' + index" v-if="!isLoading">
          <mu-avatar
            :src="item.image"
            color="white"
            backgroundColor="#E9E9E8"
            v-tooltip.bottom="item.display_name"
            @click="goTo(item.profile_url)"
          />
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-card-text>
  </mu-card>
</template>
<script>
  import DiscussionApi from '../../../api/Discussion';

  export default {
    name: "top-contributors",
    data () {
      return {
        isLoading: true,
        isSaving: false,
        data: []
      }
    },
    mounted() {
      let self = this;
      self.isLoading = true;

      if(self.$store.state.discussion.topContributors == null) {
        DiscussionApi.getDiscussionsTopContributors()
          .then(function (response) {
            self.isLoading = false;
            self.data = response.data;
            self.$store.commit('setDiscussionContributors', response.data);
          })
          .catch((err) => {})

        return;
      }

      if (self.$store.state.discussion.topContributors.length > 0) {
        self.data = self.$store.state.discussion.topContributors;
        self.isLoading = false;
      }
      else DiscussionApi.getDiscussionsTopContributors()
        .then(function (response) {
          self.isLoading = false;
          self.data = response.data;
          self.$store.commit('setDiscussionContributors', response.data);
        })
        .catch((err) => {})
    },
    methods: {
      getRandomArbitrary(min, max) {
        return Math.floor(Math.random() * (max - min) + min) + '%'
      },
      profileUrl(url) {
        url = url.split('-').join('.');
        return url;
      },
      goTo(url) {
        let self = this;
        self.$router.push({
          name: 'Profile',
          params: {
            profileUrl: url,
          }
        })
      }
    }
  }
</script>
<style lang="less">
  #top-contributors {
    .mu-card-header-title {
      padding-right: 0 !important;
    }
    .mu-avatar img {
      box-shadow: none;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// TopContributors.vue?6a453f92